import {
    apiRequest,
    flexytimeCreate
} from "../../../../../services/adapters/kepegawaian/flexytimeService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", flexytimeCreate, {
            body: query
        }, true)
    }
}

export default CreateRepository